module.exports = __webpack_public_path__ + "media/images/loader-cb36e9cee8c39a8afdd4d02df7bc9cb3.gif";